/* eslint no-param-reassign: [2, { "props": true, "ignorePropertyModificationsFor": ['cssobj'] }] */
/* eslint max-len: [2, { "code": 1025, "ignoreComments": true, "tabWidth": 4 }] */
/* eslint no-underscore-dangle: [2, {
"allow": [
	"_unstickTransitionTO1",
	"_unstickTransitionTO2",
	"_setFloor",
	"_setCeiling",
	"_stickElement"]
}] */
/* eslint class-methods-use-this: 0 */
const dqs = a => document.querySelector(a);
const gcs = a => window.getComputedStyle(a);
const offset = (el) => {
	if (!el || !el.getBoundingClientRect) {
		return {};
	}
	const rect = el.getBoundingClientRect();
	const clientTop = document.documentElement.clientTop || document.body.clientTop || 0;
	const clientLeft = document.documentElement.clientLeft || document.body.clientLeft || 0;
	const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || 0;
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
	return { top: rect.top + (scrollTop - clientTop), left: rect.left + (scrollLeft - clientLeft) };
};
const position = el => ({ left: el.offsetLeft, top: el.offsetTop });
const height = el => el.offsetHeight;

const ScrollEvent = {
	scrollEventSet: false,
	ScrollEvents: {},
	startScrollEvent() {
		const self = this;
		if (!this.scrollEventSet) {
			this.scrollEventSet = true;

			window.addEventListener('scroll', (e) => {
				Object.keys(self.ScrollEvents).forEach((key) => {
					self.ScrollEvents[key](e);
				});
			});
		}
	},
	AddToScrollEvent(e, f) {
		this.ScrollEvents[e] = f;
	},
	RemoveFromScrollEvent(e) {
		if (typeof this.ScrollEvents[e] !== 'undefined') {
			delete this.ScrollEvents[e];
		}
	},
};


/**
 *   initializes an instance acting on a specific element.
 *
 *
 */
class Sticky {
	constructor(conf, $vue) {
		this.config = conf;
		this.scrollEventName = conf.name || `scrollEvent-${Math.random()}`;
		this.startOnTouch = false;
		this.started = false;
		this.$e = null;
		this.ceiling = false;
		this.ceilingReached = false;
		this.floor = false;
		this.floorReached = false;
		this.blank = true;
		this.className = conf.className || null;
		this.css = conf.css || { background: 'white', top: '0px' };
		this.timer = conf.timer || 0;
		this.elCssStorage = null;
		this.unstick = conf.unstick || 'normal';
		this.noFloorCeil = false;
		this.noStartOnTouch = false;
		this._unstickTransitionTO1 = null;
		this._unstickTransitionTO2 = null;
		this.$vue = $vue;

		/*
		 * {
		 * element : string||OBJ
		 * blank : BOOL||OBJ, //default: true
		 * timer : int, default: 0,
		 * css : OBJ // default from element
		 * ceiling: elementOBJ||int pixels/% from top,
		 * floor: elementOBJ|| int pixels/% from top,
		 * delay: int microseconds,
		 * startOnTouch : BOOL|| { },
		 * unstick: String (normal, ease)||int speed // default: normal
		 * }
		 *
		 * examples:
		 * 1. The following will stick an element, make it stick 50px from the top, give it a yellow background, set the floor to the the element with the class "global-container-2", start the unstick process after 7 seconds, slowly move the element back into place in 4 seconds
		 * webmd.sticky.init({element : {ELEMENT}, css : { top: "50px", background: "yellow"}, ceiling: true, floor: $('.global-container-2'), timer: 7000, unstick : "4000"});
		 *
		 * 2. The following wil stick an element immediately. There will no floor or ceiling. It will start to unstick in 5 seconds and will slowly return the element to its original place in 2 seconds.
		 * webmd.sticky.init({element : {ELEMENT}, css : { top: "50px"}, timer: 5000, unstick : "ease"});
		 *
		 * 3. The following will stick an element after 5 seconds. afterwhich a ceiling will be added via the instance, a class will be added via the instance, and after 5 seconds the ad will slowly unstick over 4 seconds via the instance.
		 * var el = webmd.sticky.init({element : {ELEMENT}, delay: 5000);
		 * el.setCeiling({DIFFERENT ELEMENT});
		 * el.addClass('my-class');
		 * setTimeout(function(){
		 * el.end(4000);
		 * }, 5000);
		 *
		 * 4. The following will stick an element ONLY once you scroll down low enough so that the top of the window is close to the element, make it stick 50px from the top, set the floor to the the element with the class "global-container-2", start the unstick process after 7 seconds, slowly move the element back into place in 4 seconds
		 * webmd.sticky.init({element : {ELEMENT}, css : { top: "50px"}, startOnTouch: true, ceiling: true, floor: $('.global-container-2'), timer: 7000, unstick : "4000"});
		 */
		const self = this;

		if (typeof this.config.blank !== 'undefined') {
			this.blank = this.config.blank;
		}

		if (!this.setElement()) {
			/*
			 * TODO: put in some kind of debug
			 */
			return;
		}

		this.setCeiling();
		this.setFloor();

		if (this.config.startOnTouch) {
			this.startOnTouch = true;
		} else if (this.config.delay && !Number.isNaN(this.config.delay)) {
			setTimeout(() => {
				self.run();
			}, this.config.delay);
		} else {
			this.run();
		}

		this.startScrollEvent();
	}

	/**
	 *   This will start the sticky functionality.
	 *
	 *   @return void
	 */
	run() {
		const self = this;

		// signals that the sticky plugin has started
		this.started = true;

		this.emit('webmd-sticky-started', [this]);

		if (!this.setElement()) {
			/*
			 * TODO: put in some kind of debug
			 */
			return;
		}

		this.setCeiling();
		this.setFloor();

		if (this.blank) {
			this.createBlank(this.blank);
		}

		this.stickElement(this.css);

		if (self.checkCeiling()) {
			self.stopElementAtCeiling();
			self.noStartOnTouch = false;
		}

		if (self.checkFloor()) {
			self.stopElementAtFloor();
			self.noStartOnTouch = false;
		}

		/*
		 * timer starts and will end the sticky instance once it is reached
		 * this is used if someone wants the element to unsticky after a set time
		 */
		if (this.timer > 0) {
			setTimeout(() => {
				self.end();
			}, this.timer);
		}
	}

	/**
	 *   Sets up the element that will be stickied.
	 *   Also stores the elements original css in a variable to be reset after the element is no longer stickied
	 *
	 *   @return Boolean true if element exists, false if it doesn't
	 */
	setElement() {
		if (typeof this.config.element === 'string') {
			this.$e = this.config.element.match(/^[#.]/gi) ? document.querySelector(this.config.element) : document.getElementById(this.config.element);
		} else {
			this.$e = this.config.element;
		}

		if (!this.$e) {
			return false;
		}

		/*
		 * stores css in the elCssStorage element to be used after the element returns to normal and
		 * is no longer stickied
		 */
		if (this.elCssStorage === null) {
			this.elCssStorage = {
				position: this.getElementStyles(this.$e).position,
				zIndex: this.getElementStyles(this.$e).zIndex,
				top: this.getElementStyles(this.$e).top,
				left: this.getElementStyles(this.$e).left,
				positionTop: this.getPosition(this.$e).top,
				positionLeft: this.getPosition(this.$e).left,
				offsetTop: this.getOffset(this.$e).top,
				offsetLeft: this.getOffset(this.$e).left,
				margin: this.getElementStyles(this.$e).margin,
			};
		}

		return true;
	}

	/**
	 *   Adds a certain class to the element. this will be called when the element is stickied,
	 *   but can be used by the developer at any time
	 *
	 *   @return void
	 */
	addClass(className) {
		if (typeof this.$e.className === 'undefined' || this.$e.className === '') {
			this.$e.className = className;
		} else if (!this.$e.className.match(new RegExp(`(^|\\s+)${className}(\\s+|$)`, 'gi'))) {
			this.$e.className += ` ${className}`;
		}
	}

	/**
	 *   Removes a certain class to the element. this will be called when the element is unstickied,
	 *   but can be used by the developer at any time
	 *
	 *   @return void
	 */
	removeClass(className) {
		if (typeof this.$e.className === 'string') {
			this.$e.className = this.$e.className.split(' ').map(cn => (cn !== className ? cn : '')).filter(cn => cn !== '').join(' ');
		}
	}

	/**
	 *   Sets up the ceiling that the stickied ad will not go above.
	 *
	 *   @param  bool|int|string|object  ceiling the ceiling that the stickied element will not go above.
	 *                                           Can be a boolean "true", which would set the ceiling to the current element's lcoation
	 *                                           Can be an exact number of pixels (ie: 1000 or 1000px)
	 *                                           Can be a percentage (ie: 25%)
	 *                                           Can be an element on the page or a jquery object on an element
	 *
	 *   @return void
	 */
	setCeiling(ceiling) {
		this._setCeiling(ceiling);

		this.emit('webmd-sticky-setceiling', [this]);
	}

	_setCeiling(ceiling) {
		let $c;

		// if there is a ceiling parameter, sets the current ceiling to it
		if (typeof ceiling !== 'undefined' && ceiling !== null) {
			this.config.ceiling = ceiling;
		}

		if (typeof this.config.ceiling === 'undefined' || this.config.ceiling === null || this.config.ceiling === false) {
			return;
		}

		// if the ceiling is set to "true" it will set the ceiling to the current element's location
		if (this.config.ceiling === true && this.ceiling === false) {
			this.ceiling = `${this.parseI(this.getOffset(this.$e).top)}px`;
		} else if (!this.isNaN(this.parseI(this.config.ceiling))) {
			// if it is a number, a specific pixel set, a percentage, it will set the ceiling to that number/percentage

			this.ceiling = this.config.ceiling;
		} else if (typeof this.config.ceiling === 'string') {
			// if it is a string, we can assume the string is an id of the element you wish to be the ceiling

			$c = this.config.ceiling.match(/^[#.]/gi) ? dqs(this.config.ceiling) : document.getElementById(this.config.ceiling);
			this.ceiling = `${(this.parseI(this.getOffset($c).top) + this.parseI(this.getHeight($c)))}px`;
		} else if (typeof this.config.ceiling === 'object') {
			// if the ceiling parameter is an object, the that is assumed to be the element which will become the ceiling

			$c = this.config.ceiling;
			this.ceiling = `${(this.parseI(this.getOffset($c).top) + this.parseI(this.getHeight($c)))}px`;
		}
	}

	/**
	 *   checks to see if the ceiling was reached.
	 *
	 *   @param  int delta   extra padding between the ceiling and element.
	 *                       This is used if you want the element stopped even further below the ceiling
	 *
	 *   @return int|bool    The actual number of pixels the ceiling is|false if ceiling not reached
	 */
	checkCeiling(delta = 10) {
		this._setCeiling();

		const eltop = this.parseI(this.getOffset(this.$e).top);
		let ceiling;

		if (this.ceiling) {
			// if the ceiling was set to be a percentage, this will convert the percentage to exact pixels
			if (String.prototype.constructor(this.ceiling).indexOf('%') > -1) {
				ceiling = (this.parseI(window.innerHeight) * this.parseI(this.ceiling)) / 100;
			} else {
				ceiling = this.parseI(this.ceiling);
			}

			// adds the delta to the current ceiling in order to keep the element {delta} below the ceiling
			if (ceiling + delta > eltop) {
				return ceiling;
			}
		}

		return false;
	}

	/**
	 *   this will force the stickied element to not go above the ceiling
	 *
	 *   @return void
	 */
	stopElementAtCeiling() {
		let ceiling = this.checkCeiling();

		if (!this.ceilingReached) {
			// set the elements position to absolute
			this.$e.style.position = 'absolute';

			// calculates the total distance from the top of the stickied element
			ceiling -= this.parseI(this.getOffset(this.$e).top) - this.parseI(this.getPosition(this.$e).top);

			this.$e.style.top = `${ceiling}px`;
			this.$e.style.left = `${this.elCssStorage.positionLeft}px`;

			this.ceilingReached = true;

			this.emit('webmd-sticky-ceiling-reached', [this]);
		}
	}

	/**
	 *   This will unset any ceiling that was set.
	 *
	 *   @return void
	 */
	unsetCeiling() {
		this.config.ceiling = null;
		this.ceiling = null;
		this.emit('webmd-sticky-unsetceiling', [this]);
	}

	/**
	 *   Sets up the floor that the stickied ad will not go below.
	 *
	 *   @param  bool|int|string|object  floor   the floor that the stickied element will not go below.
	 *                                           Can be a boolean "true", which would set the below to the current element's lcoation
	 *                                           Can be an exact number of pixels (ie: 1000 or 1000px)
	 *                                           Can be a percentage (ie: 25%)
	 *                                           Can be an element on the page or a jquery object on an element
	 *
	 *   @return void
	 */
	setFloor(floor) {
		this._setFloor(floor);

		this.emit('webmd-sticky-setfloor', [this]);
	}

	_setFloor(floor) {
		let $c;

		if (typeof floor !== 'undefined' && floor !== null) {
			this.config.floor = floor;
		}

		if (typeof this.config.floor === 'undefined' || this.config.floor === null || this.config.floor === false) {
			return;
		}

		if (this.config.floor === true && this.floor === false) {
			this.floor = `${(this.parseI(this.getOffset(this.$e).top) + this.parseI(this.getHeight(this.$e)))}px`;
		} else if (!this.isNaN(this.parseI(this.config.floor))) {
			this.floor = this.config.floor;
		} else if (typeof this.config.floor === 'string') {
			$c = this.config.floor.match(/^[#.]/gi) ? dqs(this.config.floor) : document.getElementById(this.config.floor);
			this.floor = `${this.parseI(this.getOffset($c).top)}px`;
		} else if (typeof this.config.floor === 'object') {
			$c = this.config.floor;
			this.floor = `${this.parseI(this.getOffset($c).top)}px`;
		}
	}

	/**
	 *   checks to see if the floor was reached.
	 *
	 *   @param  int delta   extra padding between the floor and element.
	 *                       This is used if you want the element stopped even further above the ceiling
	 *
	 *   @return int|bool    The actual number of pixels the floor is|false if floor not reached
	 */
	checkFloor(delta = 10) {
		this._setFloor();

		const elbottom = this.parseI(this.getOffset(this.$e).top) + this.parseI(this.getHeight(this.$e));
		let floor;

		if (this.floor) {
			// if the ceiling was set to be a percentage, this will convert the percentage to exact pixels
			if (typeof this.floor === 'string' && this.floor.indexOf('%') > -1) {
				floor = (this.parseI(window.innerHeight) * this.parseI(this.floor)) / 100;
			} else {
				floor = this.parseI(this.floor);
			}

			if (floor + delta < elbottom) {
				return floor;
			}
		}

		return false;
	}

	/**
	 *   this will force the stickied element to not go below the floor
	 *
	 *   @return void
	 */
	stopElementAtFloor() {
		const floor = this.checkFloor();
		let top;


		if (!this.floorReached) {
			top = (floor - (this.parseI(this.getHeight(this.$e)) - 10));

			// you have to make it position absolute first or you can't calculate the difference between the offset and position
			this.$e.style.position = 'absolute';

			// calculates the total distance from the top of the stickied element
			top -= this.parseI(this.getOffset(this.$e).top) - this.parseI(this.getPosition(this.$e).top);

			this.$e.style.top = `${top}px`;
			this.$e.style.left = `${this.elCssStorage.positionLeft}px`;

			this.floorReached = true;

			this.emit('webmd-sticky-floor-reached', [this]);
		}
	}

	/**
	 *   This will unset any floor that was set.
	 *
	 *   @return void
	 */
	unsetFloor() {
		this.config.floor = null;
		this.floor = null;
		this.emit('webmd-sticky-unsetfloor', [this]);
	}

	/**
	 *   started the process to end the sticky instance
	 *
	 *   @return void
	 */
	end(s = 0) {
		if (this.started === true) {
			this.config = {};
			this.started = false;
			this.removeScrollEvent();
			this.unstickElement(s);
		}
	}

	/**
	 *   creates a blank element and places it in place of the now stickied element,
	 *   in order to not collapse anything around the element once it becomes stickied.
	 *
	 *   @param  object  cssobject   css that you would to put on the blank element
	 *
	 *   @return void
	 */
	createBlank(cssobj) {
		const self = this;
		const cssKeys = ['height', 'width', 'padding', 'margin', 'background', 'float'];
		const $blank = document.createElement('div');
		$blank.id = `${this.scrollEventName.replace(/\s+/gi, '')}-sticky-blank`;
		$blank.className = 'sticky-blank';

		cssKeys.forEach((v) => {
			if (typeof cssobj === 'object' && cssobj[v]) {
				$blank.style[v] = cssobj[v];
			} else {
				$blank.style[v] = this.getElementStyles(self.$e)[v];
			}
		});

		this.$e.parentNode.insertBefore($blank, this.$e);
		this.$blank = $blank;
		this.emit('webmd-sticky-createblank', [this]);
	}

	/**
	 *   removes the blank element that was filling the gap of the stickied element.
	 *
	 *   @return void
	 */
	destroyBlank() {
		if (this.$blank) {
			this.$blank.parentNode.removeChild(this.$blank);
			this.emit('webmd-sticky-removeblank', [this]);
		}
	}

	/**
	 *   sticks the element
	 *
	 *   @param  object  css any css that you want to add to the stickied element
	 *
	 *   @return void
	 */
	stickElement(css, className) {
		this._stickElement(css);

		if (className) {
			this.className = className;
		}

		if (this.className) {
			this.addClass(this.className);
		}

		this.emit('webmd-sticky-stick', [this]);
	}

	_stickElement(cssTmp) {
		const self = this;
		const css = cssTmp || this.css;
		this.css = css;

		// making the margin 0 temporarily while it is stickied
		this.$e.style.margin = '0';

		Object.keys(css).forEach((key) => {
			self.$e.style[key] = css[key];
		});

		// setting some defaults
		this.$e.style.position = 'fixed';
		this.$e.style.zIndex = css['z-index'] || css.zIndex || 10000;

		if (css.bottom) {
			this.$e.style.bottom = css.bottom;
		} else if (css.top) {
			this.$e.style.top = css.top;
		} else {
			this.$e.style.top = '0px';
		}

		if (css.left) {
			this.$e.style.left = css.left;
		} else if (css.right) {
			this.$e.style.right = css.right;
		} else {
			this.$e.style.left = `${this.parseI(this.elCssStorage.offsetLeft)}px`;
		}


		this.ceilingReached = false;
		this.floorReached = false;
	}

	/**
	 *   unsticks the stickied element
	 *
	 *   @return void
	 */
	unstickElement(s = 0) {
		const self = this;
		let timer = 0;
		let top;

		// function that will be called to restore stickied element to normal
		const resetSticky = () => {
			self.destroyBlank();
			const css = ['position', 'top', 'left', 'zIndex', 'margin'];

			for (let i = 0; i < css.length; i += 1) {
				self.$e.style[css[i]] = self.elCssStorage[css[i]];
			}

			if (self.className) {
				self.removeClass(self.className);
			}
			self.emit('webmd-sticky-finished', [self]);
		};

		// we clear the timeout in case the developer wants to end the sticky earlier than the timeout was set to
		if (this._unstickTransitionTO1 !== null) {
			clearTimeout(this._unstickTransitionTO1);
			this._unstickTransitionTO1 = null;
		}

		if (this._unstickTransitionTO2 !== null) {
			clearTimeout(this._unstickTransitionTO2);
			this._unstickTransitionTO2 = null;
		}

		// if the configged "unstick" was set to normal, will unsticky immediately
		if (this.parseI(s) === 0 && this.unstick === 'normal') {
			resetSticky();
			return;
		}

		// if the configged "ease" was set to normal, will unsticky after 2 seconds
		if (this.parseI(s) === 0 && this.unstick === 'ease') {
			timer = 2000;
		}

		if (this.parseI(s) === 0 && !this.isNaN(this.parseI(this.unstick))) {
			timer = this.parseI(this.unstick);
		}

		// if timer was set to unsticky the ad, this will unsticky it slowly via transition
		if (timer > 0) {
			top = this.parseI(this.getOffset(this.$e).top);

			if (this.$e.style.bottom) {
				this.$e.style.bottom = null;
			}

			this.$e.style.position = 'absolute';
			top -= this.parseI(this.getOffset(this.$e).top) - this.parseI(this.getPosition(this.$e).top);
			this.$e.style.top = `${top}px`;
			this.$e.style.left = `${this.elCssStorage.positionLeft}px`;

			// starts the transition to unstick ad slowly
			this._unstickTransitionTO1 = setTimeout(() => {
				self.$e.style.transition = `top ${Math.floor(timer / 1000)}s, left ${Math.floor(timer / 1000)}s`;

				setTimeout(() => {
					self.$e.style.top = `${self.parseI(self.elCssStorage.positionTop)}px`;
					self.$e.style.left = `${self.parseI(self.elCssStorage.positionLeft)}px`;
				});
			});

			// sets timer to return the sticky ad to its normal state after the transition ends
			this._unstickTransitionTO2 = setTimeout(() => {
				self.$e.style = 'transition: top 0s, left 0s';
				resetSticky();
			}, (timer) + 100);
		}
	}

	/**
	 *   updates the position of the stickied ad by resticking element
	 *
	 *   @return void
	 */
	updatePosition() {
		if (this.getElementStyles(this.$e).position === 'absolute') {
			this._stickElement();
		}
	}

	/**
	 *   checks the location of the element compared to the top of the window
	 *
	 *   @return void
	 */
	checkElementToWindow() {
		let d = this.parseI(window.scrollY);

		// if someone configged an offset it will add it
		if (typeof this.config.startOnTouch !== 'undefined' && typeof this.config.startOnTouch.offset !== 'undefined') {
			d += this.parseI(this.config.startOnTouch.offset);
		}

		/*
		 * this calculation checks to see how far the top of the window is from the top of the ad.
		 * a padding of 200 is created in order to return true on really fast scroll and to avoid
		 * getting reversed by a true from the checks to floor and ceiling
		 */
		if (Math.abs(d - this.parseI(this.getOffset(this.$e).top)) < 200) {
			return true;
		}

		return false;
	}

	/**
	 *   Starts the scroll event which will be responsible for properly setting the element to position
	 *   fixed and absolute based on the location of the file.
	 *
	 */
	startScrollEvent() {
		const self = this;

		// binds the event to a certain name in order to be able to unbind it later
		ScrollEvent.AddToScrollEvent(`scroll-${this.scrollEventName}`, () => {
			try {
				/*
				 * if the config has startOnTouch,
				 * this will wait until the window top is very close to the element before starting the sticky functionality
				 */
				if (self.startOnTouch && self.checkElementToWindow()) {
				// once this is set to false it will not wait anymore
					self.startOnTouch = false;
					self.run();
					return;
				}

				if (!self.started) {
					return;
				}

				// updates the position of the sticky with every move.
				self.updatePosition();

				/*
				 * sticks element if the window top is close to the element top,
				 * and there is no immediate floor or ceiling in the way
				 */
				if (!self.noStartOnTouch && self.checkElementToWindow()) {
					if (self.checkCeiling(-50) === false && self.checkFloor(100) === false) {
						self.stickElement();
						self.noStartOnTouch = true;
					}
				}

				// checks to see if the element reached the ceiling and will stop its movement up if true
				if (self.checkCeiling()) {
					self.stopElementAtCeiling();
					self.noStartOnTouch = false;
				}

				// checks to see if the element reached the floor and will stop its movement down if true
				if (self.checkFloor()) {
					self.stopElementAtFloor();
					self.noStartOnTouch = false;
				}
			} catch (err) {
				// an error logger to any issues that might come up
				/*
				 * TODO: put in some kind of debug
				 */
			}
		});
	}

	/**
	 *   unbinds the scroll event
	 */
	removeScrollEvent() {
		// $(window).unbind('scroll.' + this.scrollEventName);
		ScrollEvent.RemoveFromScrollEvent(`scroll-${this.scrollEventName}`);
	}

	getOffset(el) {
		if (el) {
			return offset(el);
		}

		return null;
	}

	getHeight(el) {
		if (el) {
			return height(el);
		}

		return null;
	}

	getPosition(el) {
		if (el) {
			return position(el);
		}

		return null;
	}

	parseI(i) {
		return parseInt(i, 10);
	}

	isNaN(i) {
		return Number.isNaN(i);
	}

	emit(a, b) {
		this.$vue.$emit(`${this.scrollEventName}-${a}`, b);
	}

	getElementStyles(el) {
		return gcs(el);
	}
}
export {
	Sticky,
	ScrollEvent,
	dqs,
	gcs,
	offset,
	height,
};
